import { useEffect } from 'react';
import { getTheme } from '@/config/themes';
import { useStore } from '@/store/useStore';

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const { selectedTheme } = useStore();
  
  // Always use default theme for landing page, user's theme for authenticated pages
  const isLandingPage = window.location.pathname === '/';
  const themeId = isLandingPage ? 'default' : selectedTheme;
  const theme = getTheme(themeId);

  useEffect(() => {
    // Apply theme colors as CSS variables
    const root = document.documentElement;
    
    Object.entries(theme.colors).forEach(([key, value]) => {
      root.style.setProperty(`--theme-${key}`, value);
    });

    // Apply fonts
    root.style.setProperty('--font-heading', theme.fonts.heading);
    root.style.setProperty('--font-body', theme.fonts.body);
    root.style.setProperty('--font-mono', theme.fonts.mono);

    // Apply cursor
    root.style.cursor = theme.effects.cursor;

    // Apply theme-specific body classes
    document.body.className = `theme-${theme.id}`;
    
    if (theme.effects.scanlines) {
      document.body.classList.add('scanlines');
    }
    if (theme.effects.noise) {
      document.body.classList.add('noise');
    }
    if (theme.effects.glow) {
      document.body.classList.add('glow');
    }
    if (theme.effects.animation === 'glitch') {
      document.body.classList.add('glitch-animation');
    }

    // Fallout theme specific styles
    if (theme.id === 'fallout') {
      document.body.style.fontFamily = theme.fonts.body;
      document.body.style.backgroundColor = theme.colors.background;
      document.body.style.color = theme.colors.foreground;
    }
  }, [theme, selectedTheme]);

  return <>{children}</>;
}
